import React from 'react'
import Paper from "@material-ui/core/Paper";
import { autoEllipses, copyTextToClipboard } from "helpers/helpers";
import {
  IconButton,
} from "@material-ui/core";
import { FileCopyRounded, } from "@material-ui/icons";
import { green } from "@material-ui/core/colors";
import { NotificationManager } from "react-notifications";
import GenericPdfDownloader from 'applicant/routes/dashboard/downloadPDF';


const GeneralPaymentReceipt = ({ transactionId, paymentReceipt }) => {


  const copyTransationRef = async (text) => {
    copyTextToClipboard(text);
    NotificationManager.success("Transaction Ref copied successfully");
  };

  return (
    <div>
      <GenericPdfDownloader
        downloadFileName="ReceiptPDF"
        rootElementId="content"
      />
      <Paper elevation={2} className="mb-3">
        <div className="container">
          <header
            className="mt-4 text-center"
          // style={{ borderBottom: "1px solid gray" }}
          >
            <div className="d-flex justify-content-between">
              <div style={{ maxWidth: "100px", maxHeight: "100px" }}>
                <img
                  className="img-fluid"
                  src="https://unicrossdoc.blob.core.windows.net/passport/UNICROSS%20Logo%20-%20whitebg.png?sp=r&st=2022-10-17T15:19:36Z&se=2122-10-17T23:19:36Z&spr=https&sv=2021-06-08&sr=b&sig=TlwLNipSBRc%2BhjvTbnacUYmgEvo1H7s41Jd5tHqYMkE%3D"
                  alt=""
                  style={{ maxWidth: "100px", maxHeight: "100px" }}
                />
              </div>
              <div style={{ maxWidth: "100px", maxHeight: "100px" }}>
                {/* <h1>{paymentReceipt.passport}</h1> */}
                <img
                  className="img-fluid"
                  src={paymentReceipt?.passport}
                  alt=""
                  style={{ maxWidth: "100px", maxHeight: "100px" }}
                />
              </div>
            </div>
          </header>

          <div className="mb-5 text-center text-center">
            <h1>
              <strong>Payment Receipt</strong>
            </h1>
          </div>

          <div className="d-flex justify-content-between">
            <div>
              <h5 style={{ fontSize: "18px" }}>Babalola Academy Collage of Health Technology, Ilorin </h5>
            </div>
            <div className="text-center">
              <strong>{paymentReceipt?.name}</strong>
              <p>{paymentReceipt?.jambRegNo}</p>
            </div>
            <div className="text-right">
              <strong className="text-end">
                <div className="d-flex align-items-center">
                  <span>
                    TransactionId:
                    {autoEllipses(transactionId ?? "", "200", "90")}
                  </span>
                  <IconButton onClick={() => copyTransationRef(transactionId)}>
                    {" "}
                    <FileCopyRounded
                      style={{ color: green[500], fontSize: "16px" }}
                    />{" "}
                  </IconButton>
                </div>
              </strong>
              <p>
                <strong className="text-end">RRR: {paymentReceipt?.RRR}</strong>
              </p>
              <p>
                <strong className="text-end">
                  Generated On: {paymentReceipt?.paymentDate}
                </strong>
              </p>
              <p>
                <strong>{paymentReceipt?.generatedDate}</strong>
              </p>
            </div>
          </div>
          <br />
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">Payment Reference:</th>
                <th scope="col">Method</th>
                <th scope="col">Payment For</th>
                <th scope="col">Session</th>
                <th scope="col">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{paymentReceipt?.RRR}</td>
                <td>Interswitch</td>
                <td>{paymentReceipt?.paymentName}</td>
                <td>{paymentReceipt?.session}</td>
                <td>&#8358;{paymentReceipt?.amount}</td>
              </tr>
              <tr>
                <td colspan="2"></td>
                <td colspan="2">
                  <strong className="text-right">
                    Interswitch/Bank Service Charge
                  </strong>
                </td>
                <td>&#8358;{paymentReceipt?.charges}</td>
              </tr>
            </tbody>
          </table>
          <div className="text-right">
            <h4>
              <strong style={{ fontSize: "25px" }}>Amount Paid: </strong>
              <span className="text-muted" style={{ fontSize: "35px" }}>
                &#8358;{paymentReceipt?.amount}
              </span>
            </h4>
          </div>
          <br />
          <div className="d-flex justify-content-between mb-5 mt-1">
            <div>
              <h5 className="text-muted" style={{ fontSize: "20px" }}>
                <i>
                  <strong>Verify Documentd</strong>
                </i>
              </h5>
              <div>
                {/* <h1>{paymentReceipt.passport}</h1> */}
                <img
                  className="img-fluid"
                  src={paymentReceipt?.QRcode}
                  alt=""
                  style={{ maxWidth: "130px", maxHeight: "130px" }}
                />
              </div>
            </div>
            <div className="mx-3">
              <strong>
                <h5 className="text-muted" style={{ fontSize: "20px" }}>
                  Payment Methods:
                </h5>
              </strong>
              <img
                src="https://unicrossdoc.blob.core.windows.net/passport/MicrosoftTeams-image%20(17).png"
                alt=""
                style={{ height: "50%", width: "80%", objectFit: "" }}
              />
            </div>
            <div className="mb-5">
              <img
                src="https://unicrossdoc.blob.core.windows.net/passport/MicrosoftTeams-image%20(16).png"
                alt=""
                style={{ height: "80%", width: "80%" }}
              />
            </div>
          </div>
        </div>
      </Paper>
    </div>
  )
}

export default GeneralPaymentReceipt